import { useParams } from "react-router-dom";
import UserPanelWide from "../../components/User/UserPanelWide";
import UserPanel from "../../components/User/UserPanel";
import ProfileTabs from "../../components/User/ProfileTabs";
import { useAuth } from "../../contexts/AuthContext";
import Section from "../../components/UI/Section/Section";

const UserProfile = () => {
  const { currentUser } = useAuth();
  const params = useParams();
  const userID = params.userID ? params.userID : currentUser.uid;
  return (
    <>
      {!userID && <UserPanel />}
      <Section>
        <ProfileTabs userID={userID} />
      </Section>
      <UserPanelWide userID={userID} />
    </>
  );
};

export default UserProfile;
